import { useRef } from "react";
import useResize from "../../hooks/useResize";
import Sidebar from "./Sidebar";

const SidebarFixed = ({ room, user, position }) => {
  const isLeft = position === "left";
  const ref = useRef();

  const {
    size: width,
    resizing,
    handleResize,
    handleReset,
  } = useResize({
    axis: "x",
    reverse: isLeft,
    minSize: 200,
    maxSize: document.body.clientWidth / 3,
    storageKey: "sidebarWidth",
    ref,
  });

  return (
    <aside
      className="hidden lg:flex lg:shrink-0 relative min-w-[250px] max-w-[33vw]"
      style={{ width: width || "400px" }}
      ref={ref}
    >
      <div
        className={`absolute flex flex-col group justify-center inset-y-0 transition delay-200 ${
          isLeft ? "right-0 border-r-4" : "left-0 border-l-4"
        } cursor-[ew-resize] ${
          resizing
            ? "border-primary-600"
            : "border-transparent hover:border-primary-600"
        }`}
        onMouseDown={handleResize}
        onTouchStart={handleResize}
        onDoubleClick={handleReset}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`xl:hidden ${
            isLeft ? "-mr-2.5" : "-ml-1"
          } h-6 w-6 transition delay-200 ${
            resizing
              ? "text-primary-500"
              : "text-gray-300 group-hover:text-primary-500"
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={resizing ? 2 : 1}
            d="M6 4v16M12 4v16"
          />
        </svg>
      </div>
      <div
        className={`w-full flex flex-col ${
          isLeft ? "border-r" : "border-l"
        } border-gray-300 bg-gray-200 overflow-y-auto`}
      >
        <Sidebar room={room} user={user} />
      </div>
    </aside>
  );
};

export default SidebarFixed;
